module.exports = __webpack_public_path__ + "static/media/pic1.2d18eb35.jpg";